import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/ClientApplicationCreate.css';
import { clientApplicationsType } from '../../types';
import useSingleValidator from '../../hooks/useSingleValidator';
import {
    CLIENT_APPLICATION_DESCRIPTION_MAX_LENGTH,
    CLIENT_APPLICATION_ID_MAX_LENGTH,
    settingsApplicationDescriptionValidator,
    settingsApplicationIdValidator,
} from '../../validators/settings';
import useExtendedState from '../../hooks/useExtendedState';
import TextField from '../fields/TextField';
import CheckboxField from '../fields/CheckboxField';
import { compositeValidator, wafValidator } from '../../hooks/validationSupport';

ClientApplicationCreate.propTypes = {
    clientApplications: clientApplicationsType.isRequired,
    onClientApplicationCreate: PropTypes.func.isRequired,
};

function ClientApplicationCreate(props) {
    const {
        clientApplications,
        onClientApplicationCreate,
    } = props;
    const { t } = useTranslation();
    const applicationIdState = useExtendedState(null);
    const activeState = useExtendedState(false);
    const descriptionState = useExtendedState('');
    const {
        validator: applicationIdValidator,
        isValid: isApplicationIdValid,
    } = useSingleValidator(true, useMemo(() => compositeValidator(settingsApplicationIdValidator(t, clientApplications), wafValidator(t)), [t, clientApplications]));
    const {
        validator: applicationDescriptionValidator,
        isValid: isDescriptionValid,
    } = useSingleValidator(true, useMemo(() => compositeValidator(settingsApplicationDescriptionValidator(t), wafValidator(t)), [t]));
    const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);
    const applicationIdSetPromise = applicationIdState.value ? Promise.resolve() : Promise.reject();
    Promise.all([applicationIdSetPromise, isApplicationIdValid(), isDescriptionValid()])
        .then(() => setIsAddButtonDisabled(false))
        .catch(() => setIsAddButtonDisabled(true));

    const addClientApplication = () => {
        onClientApplicationCreate(applicationIdState.value, descriptionState.value, activeState.value);
        applicationIdState.reset();
        descriptionState.reset();
        activeState.reset();
    };
    return (
        <div className="client-applications--add-client-application">
            <TextField
                label={t('settings.client-applications.table.application-id')}
                state={applicationIdState}
                className="client-applications--fields--application-id"
                inputId="client-applications--fields--application-id"
                validator={applicationIdValidator}
                maxLength={CLIENT_APPLICATION_ID_MAX_LENGTH}
            />
            <TextField
                label={t('settings.client-applications.table.description')}
                state={descriptionState}
                className="client-applications--fields--description"
                inputId="client-applications--fields--description"
                validator={applicationDescriptionValidator}
                maxLength={CLIENT_APPLICATION_DESCRIPTION_MAX_LENGTH}
            />
            <CheckboxField
                label={t('settings.client-applications.table.active')}
                state={activeState}
                className="client-applications--fields--active"
                inputId="client-applications--fields--active"
            />
            <button
                type="button"
                className="add-client-application-button button button-bordered"
                disabled={isAddButtonDisabled}
                onClick={addClientApplication}
            >
                <FontAwesomeIcon icon="plus" />&nbsp;{t('settings.client-applications.add-client-application')}
            </button>
        </div>
    );
}

export default ClientApplicationCreate;
